import { BibliographyClass, CollectionFlag, Prefix, SearchType } from '@/types'
import { exists } from '@/api'

export interface BibliographyRealReserveSetBibliography {
  id: number
  rank: number
  bibliographyRealId: number
  bibliographyClass: BibliographyClass
  prefix: Prefix
  searchType: SearchType
  displayTitle: string
  displayAuthor: string
  displayPublisher: string
  displayPublished: string
  displaySize: string
  collectionFlag: CollectionFlag
  shelfCount: number
}

export function BibliographyRealReserveSetBibliographyFromJSON(
  json: any
): BibliographyRealReserveSetBibliography {
  return {
    id: exists(json, 'id') ? json.id : 0,
    rank: exists(json, 'rank') ? json.rank : 0,
    bibliographyRealId: exists(json, 'bibliography_real_id')
      ? json.bibliography_real_id
      : 0,
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Real,
    searchType: exists(json, 'search_type')
      ? json.search_type
      : SearchType.Book,
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    displayPublisher: exists(json, 'display_publisher')
      ? json.display_publisher
      : '',
    displayPublished: exists(json, 'display_published')
      ? json.display_published
      : '',
    displaySize: exists(json, 'display_size') ? json.display_size : '',
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection,
    shelfCount: exists(json, 'shelf_count') ? json.shelf_count : 0
  }
}
